export default __webpack_public_path__ + "static/media/info.93d2f936.svg";